import { CoreSchedule, Schedule } from 'types';

function isAcfSchedule(
  schedule: Schedule | Partial<Schedule>,
): schedule is CoreSchedule {
  return schedule.variant === 'core' && !!schedule.isInAcf;
}

export const scheduleUtils = { isAcfSchedule };
